import React from "react";
import Blok from "../../../interfaces/Storyblok/Blok.interface";
import { StoryblokAsset } from "../../../interfaces/Storyblok/StoryblokAsset.interface";
import Image from "../../atoms/Image/Image.atom";

export interface CardCarouselCardProps extends Blok {
  image?: StoryblokAsset;
  logo?: StoryblokAsset;
  title?: string;
  body?: string;
}

const CardCarouselCard: React.FC<CardCarouselCardProps> = ({ image, logo, title, body }) => {
  return (
    <div className="flex h-full flex-col overflow-hidden rounded-[24px] bg-White shadow-xl">
      {image?.filename && (
        <div className="aspect-video w-full overflow-hidden">
          <Image image={image} objectFit="cover" fluidMaxWidth={800} />
        </div>
      )}

      <div className="flex flex-1 flex-col space-y-3 px-5 pb-7 pt-5">
        {(logo?.filename || title) && (
          <div className="flex items-center gap-3">
            {logo?.filename && <Image image={logo} maxWidth={56} maxHeight={56} />}
            {title && <h3 className="text-xl font-extrabold text-Primary-900">{title}</h3>}
          </div>
        )}
        {body && <p className="text-Body">{body}</p>}
      </div>
    </div>
  );
};

export default CardCarouselCard;
